import React, { useCallback, useEffect, useState } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { MutatingDots } from 'react-loader-spinner'
import TestingAccount from './TestingAccount'
import TestingStrategies from './TestingStrategies'
import { getUserByType } from './Testing.util'
import { ACTIVE_STRATEGY } from '../../utils/constants.util'

function Testing() {
  const { url, params } = useRouteMatch()
  const [user, setUser] = useState({})
  const [activeStrategy] = useState(ACTIVE_STRATEGY)
  const [showLoader, setShowLoader] = useState(false)

  const getUser = useCallback(() => {
    setShowLoader(true)

    return getUserByType(params.testType).then(response => {
      setUser(response.data)

      setTimeout(() => {
        setShowLoader(false)
      }, 500)
    })
  }, [params.testType])

  useEffect(() => {
    getUser()
  }, [getUser])

  return (
    <>
      {showLoader ? (
        <MutatingDots
          className="page-loader"
          visible={showLoader}
          height={150}
          width={150}
        />
      ) : (
        <Switch>
          <Route exact path={`${url}`}>
            <TestingStrategies strategies={user.strategies} activeStrategy={activeStrategy} />
          </Route>
          <Route path={`${url}/:strategyName/:accountName`}>
            <TestingAccount strategies={user.strategies} />
          </Route>
        </Switch>
      )}
    </>
  )
}

export default Testing
